import React, { useEffect, useState } from "react";
import { CommonContainer } from "../../../../components/Grid";
import LoadInView from "../../../../components/LoadInView";
import { ContentContainer, PageContent, Select } from "../styled";
import { GetPost, GetPrivacy, GetPrivacyList } from "../../../../api/page";
import { useParams } from "react-router-dom";

// 서버가 잠깐 실패하거나 응답 없이 끌어도 빈 화면으로 끝나지 않게:
// 요청마다 10초 제한, 실패하면 1초 쉬고 최대 2번 다시 시도한다.
const REQUEST_CONFIG = { timeout: 10000 };
const RETRY_COUNT = 2;
const RETRY_DELAY = 1000;

const withRetry = async (request, retries = RETRY_COUNT) => {
  try {
    return await request();
  } catch (error) {
    if (retries <= 0) throw error;
    await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY));
    return withRetry(request, retries - 1);
  }
};

const SectionContent = () => {
  const params = useParams();
  const [page_id, update_page_id] = useState(
    params.version ? params.version : 0
  );
  const [versions, update_versions] = useState(0);
  const [is_load_versions, set_is_load_versions] = useState(0);
  const [errorMsg, SeterrorMsg] = useState("");
  const [test, setTest] = useState("");
  const [post_data, set_post_data] = useState({
    post_id: null,
    post_title: "",
    post_content: "",
  });
  useEffect(() => {
    // if(params.version)
    if (post_data.post_id != page_id) {
      if (!page_id) {
        withRetry(() => GetPrivacy(null, REQUEST_CONFIG))
          .then((response) => {
            console.log(response);
            if (response.data.code == "200") {
              SeterrorMsg("");
              const post_data_ = response.data.body;
              set_post_data({
                post_id: post_data_.ID,
                post_title: post_data_.post_title,
                post_content: post_data_.post_content,
                post_date: post_data_.post_date,
              });
              console.log(123, response.data);
              setTimeout(() => {
                setTest(post_data_.ID);
              }, 100);
            } else {
              SeterrorMsg("게시물을 찾을 수 없습니다.");
            }
          })
          .catch((error) => {
            console.log(error);
            SeterrorMsg("개인정보처리방침을 불러오지 못했습니다. 잠시 후 새로고침해 주세요.");
          });
      } else {
        withRetry(() => GetPost({ post_id: page_id }, REQUEST_CONFIG))
          .then((response) => {
            console.log(response);
            if (response.data.code == "200") {
              SeterrorMsg("");
              const post_data_ = response.data.body;
              set_post_data({
                post_id: post_data_.ID,
                post_title: post_data_.post_title,
                post_content: post_data_.post_content,
                post_date: post_data_.post_date,
              });
            } else {
              SeterrorMsg("게시물을 찾을 수 없습니다.");
            }
          })
          .catch((error) => {
            console.log(error);
            SeterrorMsg("개인정보처리방침을 불러오지 못했습니다. 잠시 후 새로고침해 주세요.");
          });
      }
    }

    if (!is_load_versions) {
      withRetry(() => GetPrivacyList(null, REQUEST_CONFIG))
        .then((response) => {
          if (response.data.code == "200") {
            update_versions(response.data.body);
          }
        })
        .catch((err) => console.log(err));
      set_is_load_versions(1);
    }
  }, [page_id]);
  const ChangeVersion = (e) => {
    update_page_id(e.target.value);
  };

  const [v, setV] = useState(false);

  useEffect(() => {
    if (test) {
      // Add a click event listener to a common ancestor
      const commonAncestor = document.getElementById("an");

      const handleClick = (event) => {
        // Check if the clicked element has the desired class
        if (event.target.classList.contains("togglee")) {
          // Your logic here
          console.log('Div with class "yourClassName" clicked!');
          setV((p) => !p);
        }
      };

      // Attach the event listener
      commonAncestor.addEventListener("click", handleClick);

      // Clean up the event listener when the component unmounts
      return () => {
        commonAncestor.removeEventListener("click", handleClick);
      };
    }
  }, [test]); // Empty dependency array means this effect runs once, similar to componentDidMount

  const toggle = () => {};

  return (
    <>
      <CommonContainer id="an">
        <ContentContainer>
          <LoadInView>
            {!!versions && (
              <Select onChange={ChangeVersion}>
                {versions.map((version, key) => (
                  <option
                    value={version.ID}
                    selected={page_id == version.ID ? "selected" : ""}
                  >
                    {version.post_title}
                  </option>
                ))}
              </Select>
            )}
            {!!errorMsg && <p>{errorMsg}</p>}
            <PageContent
              dangerouslySetInnerHTML={{
                __html: post_data.post_content,
              }}
              className={v ? "active" : ""}
            ></PageContent>
          </LoadInView>
        </ContentContainer>
      </CommonContainer>
    </>
  );
};

export default SectionContent;
